import FacebookIcon from '@mui/icons-material/Facebook';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { getFullURL } from './shareUtils';

export const FacebookButton = ({ url, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const shareUrl = url || getFullURL();

  const handleShare = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      shareUrl
    )}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };

  return (
    <ShareButtonBase
      icon={<FacebookIcon />}
      label={intl.formatMessage({ id: 'ShareActions.facebook', defaultMessage: 'Facebook' })}
      url={shareUrl}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      onClick={handleShare}
      {...rest}
    />
  );
};

FacebookButton.propTypes = {
  url: PropTypes.string,
};

FacebookButton.defaultProps = {
  url: '',
};
